import { Component, Input } from '@angular/core';

@Component({
	selector: 'price-tag',
	template: require('./price-tag.component.html'),
	styles: [require('./price-tag.component.scss')]
})
export class PriceTagComponent {
	@Input() private price: string;

	constructor() {}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./web/modern/components/price-tag/price-tag.component.ts